import classNames from "classnames";
import { ArrowIcon } from "./icons/arrow-icon";
import { EMAIL_LIGHT_THRESHOLD, EMAIL_TEMPLATE_ICON_BY_VALUE, omitColors } from "./constants";
import { isLight } from "../../../../../utils/Color";

const EmailTemplateRow = ({
  backdropEndElement,
  icon,
  title,
  fontFamily,
  href,
  color
}) => {
  const Icon = EMAIL_TEMPLATE_ICON_BY_VALUE[icon];

  const useLightTextColor = !isLight(color, omitColors, EMAIL_LIGHT_THRESHOLD);

  const textColorClass = useLightTextColor ? 'text-[#FFF]' : 'text-[#4E4E4F]'

  /*
   * Open mailto via window.open on click (same pattern as ContactDetails /
   * Event). Safari does not reliably navigate mailto: from an <a href> inside
   * the mobile preview iframe.
   */
  const className = classNames(
    "flex w-full flex-row items-center justify-between gap-2 rounded border border-[#B3B3B3]/40 p-[14px] transition-colors duration-500",
    href && "cursor-pointer hover:brightness-95",
    textColorClass,
  );

  const inner = (
    <>
      <div className="flex min-w-0 flex-row items-center gap-2">
        {Icon && <Icon size={20} className={classNames("shrink-0", textColorClass)} />}

        <p
          className={classNames(
            "truncate text-md font-medium leading-[22px]",
            textColorClass
          )}
          style={{ fontFamily }}
        >
          {title}
        </p>
      </div>
      <ArrowIcon size={20} className={classNames("shrink-0 rtl:rotate-180", textColorClass)} />
    </>
  );

  if (href) {
    return (
      <button
        type="button"
        ref={backdropEndElement}
        className={className}
        style={{ backgroundColor: color }}
        onClick={() => {
          window.open(href, '_blank');
        }}
      >
        {inner}
      </button>
    );
  }

  return (
    <div
      ref={backdropEndElement}
      className={className}
      style={{ backgroundColor: color }}
    >
      {inner}
    </div>
  );
};

export default EmailTemplateRow;
